import styled from 'styled-components/macro';

export const StyledInfoBlock = styled.div`
  display: flex;
  flex-direction: column;
  line-height: 24px;
  font-size: 16px;
  row-gap: 4px;
  overflow-y: 'auto';

  .infoValueCell {
    white-space: normal;
    overflow-y: auto;
    word-break: break-word;
    line-height: 1.3;
    max-height: 100px;
  }
`;

export const StyledSocialNetworkApplication = styled.div`
  display: flex;
  align-items: center;
`;
